import React, {Component} from "react";
import {ExamType, ExamTypeLabel} from "../../utils/enums";
import {createOptions, Date, Enums} from "../../utils";
import {DateField, formatDate, SelectField, TextareaField, TextField} from "../form/form";
import {Col, Row} from "react-bootstrap";
import {Field} from "redux-form";
import PropTypes from "prop-types";

class ExamFields extends Component {

	constructor(props) {
		super(props);

		this.state = {
			examType: null
		}
	}

	componentWillMount() {
		this.syncEnumsAndState(this.props.initialValues);
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.initialValues !== this.props.initialValues) {
			this.syncEnumsAndState(nextProps.initialValues);
		}
	}

	syncEnumsAndState(initialValues) {
		const {parent} = this.props;
		const values = parent ? initialValues[parent] : initialValues;
		this.setState({
			examType: values ? values.examType : null
		});
	}

	name(name) {
		if (this.props.parent) {
			return this.props.parent + "[" + name + "]";
		}
		return name;
	}

	render() {
		const {parent, enums} = this.props;
		const {examType} = this.state;

		let resultsLabel = 'Popis stavu / výsledek';
		if (parent) {
			resultsLabel = 'Popis stavu';
		}

		return [
			!parent && <Row key={'exam'}>
				<Col sm={6}>
					<Field label={'Typ'} name={this.name("examType")} component={SelectField} options={createOptions(ExamTypeLabel)}
						onChangeHook={(examType) => this.setState({examType})}/>
				</Col>
			</Row>,
			!parent && <Row key={'events'}>
				<Col sm={12}>
					<Field label={'Provedené úkony'} name={this.name("examEvent")} type="text" component={TextareaField}/>
				</Col>
			</Row>,
			<Row key={'result'}>
				<Col sm={12}>
					<Field label={resultsLabel} name={this.name("examResult")} type="text" component={TextareaField}
						quickValues={["Bez klinických známek nemoci"]}/>
				</Col>
			</Row>,
			examType === ExamType.VET && <Row key={'doctor'}><Col sm={6}>
				<Field label={'Lékař'} name={this.name("examDoctor")} type="text" component={TextField} maxLength={100}/>
			</Col></Row>,
			<Row key={'examBy'}>
				<Col sm={6}>
					<Field label={'Pracovník'} name={this.name("examBy")} component={SelectField} options={Enums.createEnumItems(enums, 'user')}/>
				</Col>
				<Col sm={6}>
					<Field label={'Datum'} name={this.name("examDate")} type="text" component={DateField} maxLength="12" maxDate={Date.today()} format={formatDate}/>
				</Col>
			</Row>
		];
	}
}

ExamFields.propTypes = {
	parent: PropTypes.string,
};

export default ExamFields




// WEBPACK FOOTER //
// ./src/components/dog/ExamFields.js